var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar',{attrs:{"id":_vm.toolbarId,"side":"left"}},[_c('toolbar-insert',{attrs:{"screen":_vm.screen,"toolbar":_vm.toolbarId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }